import { render, staticRenderFns } from "./Credito.vue?vue&type=template&id=5a799c7a&scoped=true"
import script from "./Credito.vue?vue&type=script&lang=js"
export * from "./Credito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a799c7a",
  null
  
)

export default component.exports